import { useState, useEffect } from 'react'
import Router from 'next/router'

type EventHandle = (url: string, config: { shallow: boolean }) => void

const useLoading = () => {
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    const handleRouteChangeStart: EventHandle = (_, { shallow }) => {
      if (!shallow) {
        setLoading(true)
        setTimeout(() => {
          setLoading(false)
        }, 1000 * 10)
      }
    }

    const handleRouteChangeComplete = () => {
      setLoading(false)
    }

    Router.events.on('routeChangeStart', handleRouteChangeStart)
    Router.events.on('routeChangeComplete', handleRouteChangeComplete)
    Router.events.on('routeChangeError', handleRouteChangeComplete)

    return () => {
      Router.events.off('routeChangeStart', handleRouteChangeStart)
      Router.events.off('routeChangeComplete', handleRouteChangeComplete)
      Router.events.off('routeChangeError', handleRouteChangeComplete)
    }
  }, [])

  return [loading]
}

export default useLoading
